module.exports = __webpack_public_path__ + "static/media/Video_caption_5.70fa8a11.png";